import { render, staticRenderFns } from "./modalCriarVerba.vue?vue&type=template&id=5e26cf74&scoped=true&"
import script from "./modalCriarVerba.vue?vue&type=script&lang=js&"
export * from "./modalCriarVerba.vue?vue&type=script&lang=js&"
import style0 from "./modalCriarVerba.vue?vue&type=style&index=0&id=5e26cf74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e26cf74",
  null
  
)

export default component.exports